export const stackData = [
    {
        id: 1,
        name: "HTML",
        logo: "/assets/logos/html-logo.png",
    },
    {
        id: 2,
        name: "CSS",
        logo: "/assets/logos/css-logo.png",
    },
    {
        id: 3,
        name: "Javascript",
        logo: "/assets/logos/javascript-logo.png",
    },
    {
        id: 4,
        name: "React",
        logo: "/assets/logos/react-logo.png",
    },
    {
        id: 5,
        name: "SASS",
        logo: "/assets/logos/sass-logo.png",
    },
    {
        id: 6,
        name: "Heroku",
        logo: "/assets/logos/heroku-logo.png",
    },
    {
        id: 7,
        name: "VS Code",
        logo: "/assets/logos/vscode-logo.png",
    },
    {
        id: 8,
        name: "PostgreSQL",
        logo: "/assets/logos/postgres-logo.png",
    },
    {
        id: 9,
        name: "Figma",
        logo: "/assets/logos/figma-logo.png",
    },
    {
        id: 10,
        name: "InVision",
        logo: "/assets/logos/invision-logo.png",
    },
    {
        id: 11,
        name: "Adobe Creative Suite",
        logo: "/assets/logos/adobecc-logo.png",
    },
    
]

export default stackData